import { render } from "./ControlePermissoesPerfilView.vue?vue&type=template&id=4a17ec9a"
import script from "./ControlePermissoesPerfilView.vue?vue&type=script&lang=js"
export * from "./ControlePermissoesPerfilView.vue?vue&type=script&lang=js"

import "./ControlePermissoesPerfilView.vue?vue&type=style&index=0&id=4a17ec9a&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__